module.exports = {"id":"224186","name":"Jordy de Wijs","rating":"72","photo":"./data/images/photos/4/224186.png","club":{"name":"Excelsior","logo":"./data/images/clubs/Excelsior.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JordydeWijs0.json
// module id = 2143
// module chunks = 0